import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-vue';
import { useMeta } from 'vue-meta';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { LinkField } from '@sitecore-jss/sitecore-jss-vue/types/components/Link';
import { IMetaData } from '@/interfaces/entities/meta-data-interface';
import { onMounted } from 'vue';
// Define props and emitters
// ------------------------------------------------------------- //

export default /*@__PURE__*/_defineComponent({
  __name: 'MetaData',
  props: {
    route: {}
  },
  setup(__props: any) {

const props = __props;

onMounted(() => {
  if (((props.route.fields?.headScript as Field)?.value ?? false) && typeof window != 'undefined') {
    document.head.innerHTML += (props.route.fields?.headScript as Field)?.value?.toString();
  }
});

const metaData = () => {
  let meta = [
    {
      name: 'title',
      content: (props.route.fields?.metaTitle as Field)?.value?.toString() ?? undefined,
    },
    {
      name: 'description',
      content: (props.route.fields?.metaDescription as Field)?.value?.toString(),
    },
    { name: 'keywords', content: (props.route.fields?.metaKeywords as Field)?.value?.toString() },
    { name: 'contenttype', content: props.route.templateName },
  ] as IMetaData[];
  if ((props.route.fields?.socialShareImage as ImageField)?.value?.src ?? false) {
    meta.push({
      property: 'og:image',
      content: (props.route.fields?.socialShareImage as ImageField)?.value?.src?.toString() ?? '',
    });
  }
  if ((props.route.fields?.socialShareTitle as Field)?.value) {
    meta.push({
      property: 'og:title',
      content: (props.route.fields?.socialShareTitle as Field)?.value?.toString(),
    });
  }
  if ((props.route.fields?.socialShareText as Field)?.value) {
    meta.push({
      property: 'og:description',
      content: (props.route.fields?.socialShareText as Field)?.value?.toString(),
    });
  }
  if ((props.route?.fields?.customMetaAttributes as Field)?.value) {
    const metaValues = (props.route?.fields?.customMetaAttributes as Field)?.value.toString().split('&');
    metaValues.forEach((value: string) => {
      const metaFields = value.split('=');
      if (metaFields?.length == 2) {
        meta.push({
          name: metaFields[0],
          content: metaFields[1],
        });
      }
    });
  }
  if (props.route.placeholders) {
    const updated = props.route.placeholders['headless-main'].find((x) => x.componentName == 'FormBuilder')?.fields
      ?.data?.updated;
    if (updated) {
      meta.push({
        name: 'modified',
        content: updated,
      });
    }
  }
  if ((props.route.fields?.metaRobotNoIndex as Field)?.value) {
    meta.push({
      name: 'robots',
      content: 'noindex',
    });
  }

  return meta;
};
typeof window != 'undefined' &&
  useMeta({
    title: (props.route.fields?.pageTitle as Field)?.value || (props.route.fields?.Title as Field)?.value || 'Page',
    meta: metaData(),
    link: [
      {
        rel: 'canonical',
        href: (props.route.fields?.canonicalUrl as LinkField)?.value?.href
          ? (props.route.fields?.canonicalUrl as LinkField)?.value?.href
          : window.location.href.split('?')[0],
      },
    ],
  });

return (_ctx: any,_cache: any) => {
  const _component_metainfo = _resolveComponent("metainfo")!

  return (_openBlock(), _createBlock(_component_metainfo, null, {
    title: _withCtx(({ content }) => [
      _createTextVNode(_toDisplayString(content), 1)
    ]),
    _: 1
  }))
}
}

})